import React from 'react';

const FormRadiobutton = ({ blok, handleInputChange, formValue }) => {
  const { name, value, label } = blok;

  return (
    <label>
      <input
        className="form-radio bg-yellow-25 text-sm font-normal mr-1"
        type="radio"
        name={name}
        value={value}
        onChange={handleInputChange}
        checked={formValue === value} // This is the controlled component pattern. This ensures that the first radio button is checked by default.
      />
      <span className="text-sm font-normal mr-4">{`${' ' + label}`}</span>
    </label>
  );
};

export default FormRadiobutton;
